import {useState} from 'react'
import {getMasterService} from '../services'
import {GetTypeModuleDto, SelectModel} from '../model'

const useMasterListService = () => {
  const [loading, setLoading] = useState(false)
  const [masterList, setMasterList] = useState<SelectModel[]>([])

  const getMasterServiceData = async (tableName: string, aditional: any = {}) => {
    let obj: GetTypeModuleDto = {
      pageNumber: 1,
      size: 100,
      tableName,
    }
    return await getMasterService(obj, aditional)
  }

  const getMasterData = async (tableName: string, aditional: any = {}) => {
    setLoading(true)
    try {
      const response = await getMasterServiceData(tableName, aditional)
      return response.data.data
    } catch (error) {
      console.error('Error fetching master data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }
  const getMasterMappedData = async (
    tableName: string,
    code: string = 'codigo',
    name: string = 'nombreCorto',
    aditional: any = {},
  ) => {
    setLoading(true)
    try {
      const data = await getMasterData(tableName, aditional)
      const mappedSites = mapMasters(data, code, name)
      return mappedSites
    } catch (error) {
      console.error('Error fetching master data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }
  const mapMasters = (data: any[], code: string = 'codigo', name: string = 'nombreCorto') => {
    return data.map((item) => ({value: item[code], label: item[name], ...item}))
  }

  const updatemasterList = (mappedSites: {value: string; label: string}[]) => {
    setMasterList(mappedSites)
  }

  const getMasterList = async (tableName: string, aditional: any = {}) => {
    try {
      const data = await getMasterData(tableName, aditional)
      const mappedSites = mapMasters(data)
      updatemasterList(mappedSites)
    } catch (error) {
      console.error('Error fetching master data:', error)
    }
  }

  const handleClear = () => {
    setMasterList([])
  }

  return {
    loading,
    masterList,
    getMasterList,
    handleClear,
    getMasterData,
    getMasterMappedData,
  }
}

export default useMasterListService
